module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.list && _vm.list.length) ? _c('div', {
    staticClass: "special-offer-wrapper"
  }, [_c('router-link', {
    staticClass: "timer-counter",
    attrs: {
      "to": "/recommend-goods?type=13"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.img,
      "alt": "限时特价"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "counter"
  }, [_c('time-counter', {
    attrs: {
      "h": _vm.exp.h,
      "m": _vm.exp.m,
      "s": _vm.exp.s
    }
  })], 1)]), _vm._v(" "), _c('swiper', {
    ref: "mySwiper",
    attrs: {
      "options": _vm.swiperOption
    }
  }, _vm._l((_vm.list), function(item, index) {
    return (item.isToday) ? _c('swiper-slide', {
      key: index
    }, [_c('div', {
      staticClass: "goods-item"
    }, [_c('router-link', {
      attrs: {
        "to": '/goods?goods_id=' + item.goodsId,
        "target": "_blank"
      }
    }, [_c('div', {
      staticClass: "img"
    }, [_c('img', {
      attrs: {
        "src": item.imgUrl,
        "atl": item.title
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "tit"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "pri"
    }, [_vm._v("¥ " + _vm._s(item.price))])])], 1)]) : _vm._e()
  }), 1)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4ab0edbc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/home-page/specialOffers/index.vue
// module id = 1598
// module chunks = 1